import axiosInstance from "./axiosInstance";

export const apiService = {
  submitContactForm: async (formData) => {
    return axiosInstance.post("/contact", formData);
  },
  submitBooking: async (bookingData) => {
    return axiosInstance.post("/booking", bookingData);
  }
};
